module.exports = __webpack_public_path__ + "fonts/b51130d3d0c3786e260542f2771237b7-Audiowide-Regular.woff";